import React, { useState } from "react";
import AOS from "aos"; // Import AOS library
import HeroBannerSec from "../sections/homepage/HeroBannerSec";
import MapSec from "../sections/homepage/MapSec";
import TopAreaSec from "../sections/homepage/TopAreaSec";
import OurPartnersSec from "../sections/homepage/OurPartnersSec";
import { fetchAPI } from "../helper/fetchAPI";
import * as constants from "../constants";
import Search from "../components/Search";
import PropertyList from "../components/PropertyList";
import NewLaunch from "../components/NewLaunch";
import News from "../components/News";
import ContactUsForm from "../components/ContactUsForm";
import CustomHelmet from "../components/CustomHelmet";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const Home = () => {
  let apiUrl = process.env.REACT_APP_API_URL;
  let filterApiUrl = process.env.REACT_APP_API_URL;
  const countryPrefix = useCountryPrefix();


  const { i18n } = useTranslation();
  const [homeSection, setHomeSection] = useState();
  const [mapSection, setMapSection] = useState();
  const [offerSection, setOfferSection] = useState();
  const [newLaunchSection, setNewLaunchSection] = useState();
  const [topAreaSection, setTopAreaSection] = useState();
  const [propertyListSection, setPropertyListSection] = useState();
  const [propertyTypesSection, setPropertyTypesSection] = useState();
  const [propertiesSection, setPropertiesSection] = useState();
  const [ourPartnersSection, setOurPartnersSection] = useState();
  const [ourNewsSection, setOurNewsSection] = useState();
  const [filterSection, setFilterSection] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [contactDetails, setContactDetails] = useState();


  const fetchData = async () => {
    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    try {
      apiUrl = `${apiUrl}${constants.homepage}?language=${language}&region_id=${countryPrefix}`;
      const res = await fetchAPI(apiUrl, "Get");
      if (res?.status === 200) {

        const section = res.data.sections;
        setHomeSection(section.find((item) => item.sectionId === "HeroSection"));
        setMapSection(section.find((item) => item.sectionId === "MapSection"));
        setOfferSection(section.find((item) => item.sectionId === "OfferSection"));
        setNewLaunchSection(section.find((item) => item.sectionId === "LaunchSection"));
        setTopAreaSection(section.find((item) => item.sectionId === "AreaSection"));
        setPropertyListSection(section.find((item) => item.sectionId === "PropertySection"));

        const sectionData = section.find((item) => item.sectionId === "PropertySection")
        setPropertyTypesSection(sectionData.sectionItems.find((item) => item.propertyTypes)?.propertyTypes);
        setPropertiesSection({ items: sectionData.sectionItems.find((item) => item.items)?.items });

        setOurPartnersSection(section.find((item) => item.sectionId === "PartnerSection"));
        setOurNewsSection(section.find((item) => item.sectionId === "NewsSection"));

        setContactDetails(res.data.contactDetails)
        setIsLoaded(true)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    try {
      filterApiUrl = `${filterApiUrl}${constants.searchfilters}?language=${language}&region_id=${countryPrefix}`

      const resFilter = await fetchAPI(filterApiUrl, "Get");
      if (resFilter?.status === 200) {
        //some logic after api call
        setFilterSection(resFilter?.data)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-in-out",
    });
    fetchData();
  }, []);

  if (!isLoaded) {
    return (
      <FullScreenLoader style={{ minHeight: '100vh' }} />
    )
  }

  return (
    <>

      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
      />
      {!isLoaded && <FullScreenLoader style={{ minHeight: '100vh' }} />}
      <HeroBannerSec data={homeSection || {}} filters={filterSection} />
      {/* <Search filters={filterSection} /> */}
      <MapSec data={mapSection || {}} offerData={offerSection || {}} />
      <PropertyList data={propertyListSection} propertyTypeData={propertyTypesSection} propertiesData={propertiesSection} isUrlAppend={true} contact={contactDetails} />
      <NewLaunch data={newLaunchSection || {}} />
      <TopAreaSec data={topAreaSection || {}} />
      <OurPartnersSec data={ourPartnersSection || {}} />
      <News data={ourNewsSection || {}} />
      <ContactUsForm imgDiv={false} />
    </>
  );
};

export default Home;
